<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="$route.path != '/login'"
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense>
          <v-list-item :to="{
          name: 'apikeys-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-key-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Chaves API</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{
          name: 'types-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-format-list-bulleted-type</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Tipos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
 
        <v-list-item :to="{
          name: 'wineries-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-briefcase-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Vinicolas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{
          name: 'regions-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-map-marker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Regiões</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{
          name: 'castes-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-fruit-grapes-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Castas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{
          name: 'foods-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-food</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Comida</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{
          name: 'wines-list'
        }">
          <v-list-item-icon>
            <v-icon>mdi-bottle-wine-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Vinhos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{
          name: 'user'
        }">
          <v-list-item-icon>
            <v-icon>mdi-lock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Password</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="!$store.state.isUserLoggedIn" :to="{
          name: 'login'
        }">
          <v-list-item-icon>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="$store.state.isUserLoggedIn" @click="logout()">
          <v-list-item-icon>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="$route.path != '/login'">
          <v-icon>mdi-menu</v-icon>
        </v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">Wine and Dine</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <p v-if="user" class="ma-2">{{user.name}}</p>
      <v-btn icon large>
        <v-avatar size="32px" tile>
          <img src="@/assets/infordio.png" alt="Infordio" />
        </v-avatar>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container fluid fill-height>
        <router-view></router-view>
      </v-container>

      <v-snackbar v-model="snackbar.showing" :timeout="6000" :color="snackbar.color">
        {{snackbar.text}}
        <v-btn text @click="snackbar.showing = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "App",
  computed: {
    ...mapState(["snackbar", "user", "isUserLoggedIn"])
  },
  data: () => ({
    active: false,
    dialog: false,
    drawer: null
  }),
  methods: {
    logout() {
      try {
        this.$store.dispatch("setToken", null);
        this.$store.dispatch("setUser", null);
        this.$store.dispatch("setLogTime", null);
        
      } catch (error) {
        this.$store.dispatch("setSnackbar", {
          color: "error",
          text: error.message
        });
      }
    }
  },
  watch: {
    isUserLoggedIn(newValue) {
      if (!newValue) {
        this.$router.push({
          name: "login"
        });
      }
    }
  },beforeCreate()
  {
      this.$store.dispatch("setSnackbar", {
          showing: false,
          color: "error",
          text: ""
        });
  }
};
</script>
